import React, { useContext } from 'react'

import { ContactTemplateStoreContext } from '../../contexts'
import { ContactTemplatesStore } from '../../types'

const useContactTemplatesStore = (): ContactTemplatesStore => {
   const contactTemplatesStore = useContext(ContactTemplateStoreContext)

   if (!contactTemplatesStore) {
      throw new Error(
         'Expected to be wrapped in Contact Template Store Provider'
      )
   }

   return contactTemplatesStore
}

export { useContactTemplatesStore }
